var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"app-container--width-max"},[_c('v-overlay',{attrs:{"value":_vm.overlay}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1),(!_vm.overlay)?_c('StepperBase',{attrs:{"sections":_vm.form.sections}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }